export default "__VITE_ASSET__PX66SUN7__"